<style>
	.home-container {
		display: flex;
		@media (max-width: 991px) {
			width: max-content;
			}
		}

	app-calendar, .home-container .fc-scrollgrid > thead {
      width: 400px !important;
	  position: relative;
	}

	.calendar-above-row .home-vers {
      width: 400px !important;
	}

	.followup-patient-on-home {
		@media (max-width: 991px) {
			/* min-width: 2000px; */
		}
	}
</style>
<!-- <div>
	<app-mobile-tabs
		isHome
		[activeColumn]="showColumn"
		(onClick)="updateShowColumnLocal($event)"
	/> -->

	<div class="home-container">
		<app-calendar
				isHome
				(loadingIsTrue)="isLoading = true"
				(outputAction)="calendarChange($event)"
			/>
			<!-- (evClick)="calendarClick($event)" (dayEvents)="dayEventsChange($event)" (refreshLastEv)="refreshLastEv()" -->

		<div class="followup-patient-on-home"
		>
			@if (fusObj?.user_id) {
				<app-banner
					[isLoading]="isLoading"
					[person]="user"
					type="user"
				/>
				<div class="d-flex"
						#center
					>
						@if (followup) {
							<app-home-meeting
								[followup]="followup"
								(moveToOtherFollowup)="moveToOtherFollowup($event)"
								class="user-home-meeting-wrapper"
							/>
						}
				</div>
			}

			@if (fusObj?.patient_id || !fusObj) {
				<app-patient
					#patientComponent
					[showColumn]="showColumn"
					isHome
					[patient]="patient"
					[followup]="followup"
					[isLoading]="isLoading"
					[timeStatus]="timeStatus"
					[dayEventsLength]="dayEvents.length"
					(moveToOtherFollowup)="moveToOtherFollowup($event)"
					(updateShowColumn)="showColumn = $event"
				/>
			}
		</div>
	</div>
<!-- </div> -->
